/**
 * ProcessingBubble Component
 * 
 * Renders a loading indicator bubble when Analysis Mode is processing a function call.
 * Shows a spinner with "A processar..." text to indicate activity.
 */

import { useTranslation } from 'react-i18next';
import { getLocalizedCharacterName, MultilingualCharacterName } from '../utils/characterName';

interface ProcessingBubbleProps {
  avatarImageUrl?: string;
  characterName?: string | MultilingualCharacterName;
}

export default function ProcessingBubble({ 
  avatarImageUrl, 
  characterName
}: ProcessingBubbleProps) {
  const { t } = useTranslation();
  const localizedName = getLocalizedCharacterName(characterName);
  
  return (
    <div className="flex items-start gap-2 md:gap-3 justify-start pl-3 md:pl-8">
      {avatarImageUrl && (
        <img 
          src={avatarImageUrl} 
          alt={localizedName}
          className="w-6 h-6 md:w-8 md:h-8 rounded-full object-cover flex-shrink-0 opacity-70"
        />
      )}
      <div className="p-2 md:p-3 rounded-lg bg-amber-500/30 backdrop-blur-sm border border-amber-400/10 max-w-[75%] md:max-w-md">
        <div className="flex items-center gap-2">
          {/* Animated spinner */}
          <div className="animate-spin rounded-full h-4 w-4 border-2 border-amber-400 border-t-transparent flex-shrink-0"></div>
          {/* Processing text */}
          <span className="text-amber-200 text-xs md:text-sm italic leading-relaxed">
            {t('scenario.session.analysisMode.processing', 'A processar...')}
          </span>
        </div>
      </div>
    </div>
  );
}
